import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';

import requestClient from '../../utils/requestClient';
import {resourceMapper} from '../../utils/resourceMapper';
import Image from '../../components/Elements/Image';
import Video from '../../components/Elements/Video';
import DownloadButton from '../../components/Elements/DownloadButton';
import ArticleBreadcrumb from '../../components/Elements/ArticleBreadcrumb';
import RelatedArticles from '../../components/Sections/RelatedArticles';
import { pillarMapper } from '../../utils/pillarMapper';
import PillarPill from '../../components/Elements/PillarPill';
import { trackContentView } from '../../utils/api';

const Sentiment = () => {
  const type = 'sentiment'
  const { id } = useParams();

  const resource = resourceMapper(type)

  const [article, setArticle] = useState(null);

  useEffect(() => {
    async function getArticle() {
      const response = await requestClient().get(`/api/v2/${type}/${id}`)
      setArticle(response.data.data);
      trackContentView(id, type)
    }
    getArticle();
  }, []);

  return (article ?
    <main>
      <article className='bg-white'>
        <div className='container py-8 lg:py-12'>
          <div className='flex items-center justify-between mb-8'>
            <ArticleBreadcrumb article={article.content} />
            {'pillar' in article.content ? (<PillarPill pillar={pillarMapper(article.content.pillar)} size='lg' />) : null}
          </div>

          <div className='max-w-[768px] mx-auto'>
            <h1 className='mb-8'>{article.content.title}</h1>
                {article.content.video_file ? (
                <Video src={article.content.video_file} className="aspect-video w-full rounded-xl lg:rounded-2xl" />
                ) : (<Image src={article.content.image} className="aspect-video w-full rounded-xl lg:rounded-2xl" />)}

                {article.content.pdf_document && <DownloadButton content={article.content.pdf_document} />}

                <section>
                {'description' in article ? (
                    <div className="mt-8 prose whitespace-pre-line">
                    <p>{article.content.description}</p>
                    </div>
                ) : null}

                {'content' in article.content ? (
                    <div className="mt-8 prose whitespace-pre-line">
                    <p>{article.content.content}</p>
                    </div>
                ) : null}
                </section>
            </div>
        </div>
      </article>
      <RelatedArticles article={article} />
    </main>
    : null);
};

export default Sentiment;